import React from 'react';
import { Link, Typography } from 'components/alf-design';

export const WEST_POINT_CUSTOMER_PORTAL_URL =
  'https://slideinsurance.insursys.com/CustomerPortal/';

export const westPointCustomerPortalLinkProps = {
  href: WEST_POINT_CUSTOMER_PORTAL_URL,
  target: '_blank',
  rel: 'noopener noreferrer',
};

const WestPointPolicyErrorMessage = () => (
  <div className="west-point-policy-error">
    <Typography type="error" component="p">
      Oops! This policy lives in a different customer portal.
    </Typography>
    <Typography type="error" component="p">
      Your policy is managed in a separate system. You&apos;ll be able to view
      your policy and make payments there.
      <br />
      Use the link below to sign in or register.
    </Typography>
    <Link
      {...westPointCustomerPortalLinkProps}
      type="primary"
      id="west-point-customer-portal-link"
      data-dd-action-name="west_point.customer_portal.open"
      className="!text-legacy-error underline font-bold"
    >
      Go to your customer portal
    </Link>
  </div>
);

export default WestPointPolicyErrorMessage;
